import React, { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

import "./Book.scss";

import { client, urlFor } from "../../client";
import { AppWrap, MotionWrap } from "../../wrapper";
import { motion } from "framer-motion";
import Button from "../../components/Button/Button";

const Book = () => {
  const [books, setBooks] = useState([]);
  const [certificates, setCertificates] = useState([]);
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

  useEffect(() => {
    const query = '*[_type == "books"]';

    client.fetch(query).then((data) => {
      setBooks(data);
    });
  }, []);

  useEffect(() => {
    const query = '*[_type == "certificates"]';

    client.fetch(query).then((data) => {
      setCertificates(data);
    });
  }, []);

  return (
    <div>
      <h2 className="head-text">Learning Process </h2>
      <br />
      <br />
      <br />
      <div className="book_page">
        <div>
          <h2 style={{ textAlign: "center" }}>
            Certificates - {"(" + certificates?.length + ")"}
          </h2>
          <br />
          <Carousel
            autoPlay={true}
            infiniteLoop={true}
            showArrows={true}
            interval={3000}
            dynamicHeight={true}
            showThumbs={false}
            showIndicators={false}
            showStatus={false}
            width={300}
          >
            {certificates?.map((item, i) => {
              return (
                <div key={i}>
                  <img src={urlFor(item.imgUrl)} alt="icon" />
                </div>
              );
            })}
          </Carousel>
          <br />
          <br />
        </div>
        <div>
          <h2 style={{ textAlign: "center" }}> Books - {"(" + books?.length + ")"}</h2>
          <br />
          <Carousel
            autoPlay={true}
            infiniteLoop={true}
            showArrows={true}
            interval={3000}
            dynamicHeight={true}
            showThumbs={false}
            showIndicators={false}
            showStatus={false}
            width={300}
          >
            {books?.map((item, i) => {
              return (
                <div
                  key={i}
                  style={{
                    textAlign: "center",
                    justifyContent: "center",
                    margin: "auto",
                  }}
                >
                  {/* <h3>{item.title}</h3>
                  <br /> */}
                  <img src={urlFor(item.imgUrl)} alt="icon" />
                </div>
              );
            })}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default AppWrap(MotionWrap(Book, "app__book"), "book", "app__primarybg");
